import local from './local';
import development from './development';
import test from './test';
import production from './production';

export default {
  local,
  development,
  test,
  production
};
